module.exports = __webpack_public_path__ + "static/media/support.3697cb77.png";